/**
 * Plot Matrix (JSON) dev-tool — plot/garage separator row.
 *
 * Mirrors `PlotMatrix.tsx`'s own separator-injection logic (both its Plot
 * View and Stage View copies): when the row list contains any garage rows,
 * insert one sentinel row immediately before the first garage row so the
 * table can render a full-width "GARAGES" divider. Generic over both views'
 * row shapes since both only need `rowType` to decide where it goes.
 */
export interface PlotMatrixSeparatorRow {
  key: string;
  _isSeparator: true;
}

export function insertGarageSeparatorRow<T extends { rowType?: string }>(
  rows: T[],
): Array<T | PlotMatrixSeparatorRow> {
  const hasGarageRows = rows.some((row) => row.rowType === 'garage');
  if (!hasGarageRows) return rows;

  const result: Array<T | PlotMatrixSeparatorRow> = [];
  let inserted = false;
  rows.forEach((row) => {
    if (!inserted && row.rowType === 'garage') {
      result.push({ key: '__garage_separator__', _isSeparator: true });
      inserted = true;
    }
    result.push(row);
  });
  return result;
}
